const routes = [
    // Student
    {
        path: "/visitor-student/application/login",
        component: () => import("../student/pages/Login.vue"),
    },
    {
        path: "/visitor-student/application/register",
        component: () => import("../student/pages/Register.vue"),
    },
    {
        path: "/visitor-student/application/forgot/password",
        component: () => import("../student/pages/ForgotPassword.vue")
    },
    {
        path: "/visitor-student/application/form",
        component: () => import("../student/pages/ApplicationForm.vue"),
    },
    // Admin
    {
        path: "/visitor-student/applications",
        component: () => import("../admin/pages/Index"),
        meta: {
            isAuthenticated: true,
        }
    }
];

export default routes;
